import React from 'react';
import dynamic from 'next/dynamic';
import Layout from '../components/Layout';
import withApollo from '../lib/apollo';
import loading from '../lib/loading';
import redirectRouteToDomain from '../lib/redirectRouteToDomain';
import { executiveLocales } from '../lib/hasExecutivePage';

const Executive = dynamic(() => import('../components/Executive'), {
  ssr: true,
  loading,
});

const ExecutivePage = () => (<Executive />);

ExecutivePage.getInitialProps = redirectRouteToDomain(
  'executive',
  executiveLocales,
);

ExecutivePage.getLayout = ((page) => <Layout isExecutive>{page}</Layout>);

export default withApollo(ExecutivePage);
